<template>
  <div class="titulo">
    <v-container grid-list-md localContainer>
      <v-layout row wrap>
        <transition name="fade">
          <v-flex xs12 lg12 pl-4 pr-4 v-if="error === true" class="white--text text-center">
            <v-alert :value="true" type="warning">Título não encontrado ou indisponível no momento.</v-alert>
          </v-flex>
        </transition>

        <v-flex xs12 lg12 pl-4 pr-4 v-if="error === false" class="white--text backgroundVFlex">
          <h1 class="headline mb-2 mt-2">{{title.name}}</h1>
          <div class="titulo-chips">
            <span class="item">{{title.publisher.name}}</span>
            <span
              class="item"
              v-if="parseInt(title.issueCount) === 1"
            >{{title.issueCount}} {{$t('text.Edition')}}</span>
            <span class="item" v-else>{{title.issueCount}} {{$t('text.Editions')}}</span>
          </div>
          <div v-html="title.description" class="mt-4 mb-3"></div>
        </v-flex>

        <v-layout class="flex xs12 relative wrapper-loading mt-4 pl-4 pr-4">
          <transition name="fade">
            <loading v-if="title.issues.length == 0 && error === false"></loading>
          </transition>

          <transition-group name="fade" tag="v-layout" class="xs12 row wrap">
            <card-issue
              v-for="item in title.issues"
              :key="`issue-${item.id}`"
              :id="item.id"
              :issue="item"
              :isFree="item.isFree"
              :img="item.cover"
              :title="title.name"
              :subtitle="$t('text.Edition') + ' ' + item.number"
              class="theme--dark"
            ></card-issue>
          </transition-group>
        </v-layout>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from 'axios';
import bus from '@/utils/bus';
import loading from '@/components/Loading';
import cardIssue from '@/components/cardIssue';

export default {
  name: 'titulo',
  components: {
    loading,
    'card-issue': cardIssue
  },
  metaInfo() {
    return {
      title: this.title.name
        ? 'Super Comics - ' + this.title.name
        : 'Super Comics'
    };
  },
  data() {
    return {
      error: false,
      sendingFavorite: false,
      title: {
        name: '',
        issues: [],
        publisher: {
          name: ''
        }
      },
      authors: {
        art: [],
        writer: [],
        cover: []
      }
    };
  },
  watch: {},
  mounted() {
    this.sendingForm = true;
    this.getTitulo();
  },
  methods: {
    getTitulo() {
      axios
        .get('/api/titles/' + this.$route.params.titleId + '?page=1&limit=100')
        .then(response => {
          // console.dir(response.data)
          this.$store.commit(
            'setSubscription',
            response.headers['active-subscription']
          );

          this.title = response.data;

          response.data.authors.map(elem => {
            let item = {};
            item.name = elem.name;
            item.id = elem.id;

            if (elem.role === 'writer') {
              this.authors.writer.push(item);
              //this.$set(this.authors, 'writer', item)
            } else if (elem.role === 'art') {
              this.authors.art.push(item);
              //this.$set(this.authors, 'art', item)
            } else if (elem.role === 'cover') {
              this.authors.cover.push(item);
              //this.$set(this.authors, 'cover', item)
            }
          });

          bus.$emit('loading', false);
          this.sendingForm = false;
        })
        .catch(e => {
          console.error(e);

          this.error = true;

          bus.$emit('loading', false);
        });
    }
  }
};
</script>

<style lang="scss">
@import '../assets/css/_variables';

.localContainer {
  padding: 0 !important;
}
.Titulo {
  .columns {
    -webkit-column-count: 3;
    -moz-column-count: 3;
    column-count: 3;
    -webkit-column-gap: 40px;
    -moz-column-gap: 40px;
    column-gap: 40px;
    -webkit-column-rule: 1px solid lightblue;
    -moz-column-rule: 1px solid lightblue;
    column-rule: 1px solid lightblue;

    > div {
      flex: none;
      flex-wrap: none;
    }
  }

  main.v-content {
    height: 100%;
    background: $bar;

    & > .v-content__wrap {
      position: relative;
      z-index: 1;

      &:before {
        content: '';
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        position: absolute;
        z-index: -2;
        // background: url('../assets/img/background-titulo.png') no-repeat 50% 10%;
        background-size: cover;
        opacity: 0.12;
      }

      &:after {
        content: '';
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        position: absolute;
        z-index: -1;
        background: -moz-linear-gradient(
          top,
          rgba(7, 11, 71, 0) 0%,
          rgba(7, 11, 71, 0) 1%,
          rgba(7, 11, 71, 1) 100%
        );
        background: -webkit-linear-gradient(
          top,
          rgba(7, 11, 71, 0) 0%,
          rgba(7, 11, 71, 0) 1%,
          rgba(7, 11, 71, 1) 100%
        );
        background: linear-gradient(
          to bottom,
          rgba(7, 11, 71, 0) 0%,
          rgba(7, 11, 71, 0) 1%,
          rgba(7, 11, 71, 1) 100%
        );
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00070b47', endColorstr='#070b47', GradientType=0);
      }
    }
  }
}

.titulo {
  height: 100%;

  &:before {
    content: '';
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    position: absolute;
    z-index: 0;
    background: rgba(255, 255, 255, 1);
    // background: -moz-linear-gradient(top, rgba(7, 11, 71, 0) 0%, rgba(7, 11, 71, 0) 1%, rgba(7, 11, 71, 1) 100%);
    // background: -webkit-linear-gradient(top, rgba(7, 11, 71, 0) 0%, rgba(7, 11, 71, 0) 1%, rgba(7, 11, 71, 1) 100%);
    // background: linear-gradient(to bottom, rgba(7, 11, 71, 0) 0%, rgba(7, 11, 71, 0) 1%, rgba(7, 11, 71, 1) 100%);
  }

  div {
    z-index: 2;
  }

  &-cover {
    border-radius: 4px;
  }

  &-chips {
    font-size: 14px;

    .item {
      margin-right: 15px;
    }

    .v-hip {
      border-radius: 5px;
      font-size: 14px;
      top: -1px;

      .v-chip__content {
        height: 22px;
        padding: 0 8px;
      }
    }
  }
}

.warning {
  background-color: $primary !important;
}
.backgroundVFlex {
  background: linear-gradient(
    145deg,
    rgba(52, 38, 94, 1) 0%,
    rgba(18, 17, 32, 1) 100%
  );
}

.v-alert {
  border-radius: 3px;
}
</style>
